import { IBaseAction } from "../Actions/BaseAction";
import { VoidGapFiltersEnum } from "../Enums/VoidGapFilters";
import { VoidGapFilterMap } from "./VoidGapFilterTypes";

export type SetVoidGapFiltersActionType = IBaseAction<VoidGapFilterMap>
export type SetVoidGapFilterViewActionType = IBaseAction<VoidGapFiltersEnum>
export type VoidGapActionType = 
SetVoidGapFiltersActionType |
SetVoidGapFilterViewActionType


export const SET_VG_FILTERS = 'SET_VG_FITLERS';
export const SET_VG_FILTER_VIEW = 'SET_VG_FILTER_VIEW';
